import { Avatar, Box, Button, Stack, Typography } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { FacebookReelShareIcon } from '../icons/FacebookReelShareIcon';
import { FacebookReelBookmarkIcon } from '../icons/FacebookReelBookmarkIcon';
import { colors } from 'theme/mui/colors';
import { SocialMediaTypes } from 'types/socialMediaTypes';
import { SocialMediaPlatformPreviews } from 'constants/enums/general';
import { InstagramSendIcon } from '../icons/InstagramSendIcon';

const ReelPreview = (props: SocialMediaTypes) => {
  const { imageUrl, postText, type } = props;
  return (
    <Box
      style={{
        position: 'relative',
        width: '100%',
        maxWidth: '384px',
        margin: '0 auto',
        backgroundColor: '#000000',
        borderRadius: '1rem',
        overflow: 'hidden',
      }}
    >
      <Box
        style={{
          position: 'relative',
          aspectRatio: '9/16',
        }}
      >
        <img
          src={imageUrl || '/placeholder.svg'}
          alt="Reel content"
          style={{
            width: '100%',
            height: '100%',
            opacity: '0.9',
            objectFit: 'cover',
          }}
        />

        {/* Top Controls */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          style={{
            position: 'absolute',
            top: '1rem',
            left: '1rem',
            right: '1rem',
          }}
        >
          <Stack direction="row" gap="0.75rem" alignItems="center">
            <Avatar src="/avatar-ads-icon.svg" />
            <Stack direction="row" alignItems="center" gap="0.5rem">
              <Typography variant="subtitle1" color={colors.base.white}>
                {'username'}
              </Typography>
              <Button
                style={{
                  height: '1.5rem',
                  padding: '0 0.75rem',
                  fontSize: '0.75rem',
                  color: colors.base.white,
                  border: `1px solid ${colors.base.white}`,
                  borderRadius: '0.25rem',
                }}
              >
                Follow
              </Button>
            </Stack>
          </Stack>
          <Button
            style={{
              color: colors.base.white,
            }}
          >
            <MoreHorizIcon style={{ width: '1.25rem', height: '1.25rem' }} />
          </Button>
        </Stack>

        {/* Bottom Controls */}
        <Box
          style={{
            position: 'absolute',
            bottom: '1rem',
            right: '1rem',
          }}
        >
          <Button
            style={{
              color: colors.base.white,
              marginBottom: '0.5rem',
            }}
          >
            <VolumeUpIcon style={{ width: '20px', height: '20px' }} />
          </Button>
        </Box>

        {/* Side Actions */}
        <Stack
          style={{
            position: 'absolute',
            right: '1rem',
            bottom: '5rem',
            gap: '1rem',
          }}
        >
          <Stack alignItems="center">
            <Button
              style={{
                color: colors.base.white,
              }}
            >
              <FavoriteBorderIcon
                style={{
                  width: '1.5rem',
                  height: '1.5rem',
                }}
              />
            </Button>
            <Typography variant="subtitle2" color={colors.base.white}>
              {789}
            </Typography>
          </Stack>

          <Stack alignItems="center">
            <Button
              style={{
                color: 'white',
                backgroundColor: 'transparent',
                border: 'none',
                transform: 'scale(1)',
                transition: 'transform 0.2s',
              }}
            >
              <ChatBubbleOutlineIcon style={{ width: '1.5rem', height: '1.5rem' }} />
            </Button>
            <Typography variant="subtitle2" color={colors.base.white}>
              130
            </Typography>
          </Stack>
          <Stack alignItems="center">
            <Button
              style={{
                color: colors.base.white,
              }}
            >
              {type === SocialMediaPlatformPreviews.FACEBOOK_REEL ? (
                <FacebookReelShareIcon style={{ width: '1.5rem', height: '1.5rem' }} />
              ) : (
                <InstagramSendIcon style={{ width: '1.5rem', height: '1.5rem' }} />
              )}
            </Button>
            <Typography color={colors.base.white}>{120}</Typography>
          </Stack>

          <Button
            style={{
              color: 'white',
              backgroundColor: 'transparent',
              border: 'none',
              transform: 'scale(1)',
              transition: 'transform 0.2s',
            }}
          >
            <FacebookReelBookmarkIcon
              style={{
                width: '1.5rem',
                height: '1.5rem',
              }}
            />
          </Button>
        </Stack>
      </Box>

      {/* Caption */}
      <Stack
        style={{
          position: 'absolute',
          bottom: '0',
          left: '0',
          right: '0',
          background: 'linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent)',
          padding: '1rem',
          paddingTop: '2rem',
        }}
      >
        <Typography variant="h5" color={colors.base.white}>
          {'username'}
        </Typography>
        <Typography color={colors.base.white} variant="subtitle2">
          {postText}
        </Typography>
      </Stack>
    </Box>
  );
};

export default ReelPreview;
